import { URLS } from '../constants'
import { dispatchFetchGet, dispatchFetchPost, dispatchFetchPut } from './ActionsUtil'
import {
  CLEAR_ADDED_PRODUCTS,
  CLEAR_CURRENT_PRODUCT_TABLE_INFO,
  GET_CURRENT_PRODUCT_TABLE_BEGIN, GET_CURRENT_PRODUCT_TABLE_FAILURE, GET_CURRENT_PRODUCT_TABLE_SUCCESS,
  GET_PRODUCT_TABLES_BEGIN, GET_PRODUCT_TABLES_FAILURE, GET_PRODUCT_TABLES_SUCCESS, INSERT_PRODUCT_TABLE_DATA, POST_ADD_PRODUCT_BEGIN, POST_ADD_PRODUCT_FAILURE, POST_ADD_PRODUCT_SUCCESS, POST_CREATE_PRODUCT_TABLE_BEGIN, POST_CREATE_PRODUCT_TABLE_FAILURE, POST_CREATE_PRODUCT_TABLE_SUCCESS, PUT_UPDATE_PRODUCT_TABLE_BEGIN, PUT_UPDATE_PRODUCT_TABLE_FAILURE, PUT_UPDATE_PRODUCT_TABLE_SUCCESS, RESET_PRODUCT_TABLE_STATE
} from '../constants/ActionTypes'

const acGetCurrentProductTableBegin = () => ({ type: GET_CURRENT_PRODUCT_TABLE_BEGIN, })
const acGetCurrentProductTableSuccess = payload => ({
  type: GET_CURRENT_PRODUCT_TABLE_SUCCESS, payload: { response: payload }
})
const acGetCurrentProductTableFailure = err => ({
  type: GET_CURRENT_PRODUCT_TABLE_FAILURE, payload: err
})

export const acGetCurrentProductTable = () => {
  return dispatchFetchGet(
    `${URLS.PRODUCT.CURRENT_PRODUCT_TABLE}`,
    acGetCurrentProductTableBegin,
    acGetCurrentProductTableSuccess,
    acGetCurrentProductTableFailure,
  )
}

const acGetProductTablesBegin = () => ({ type: GET_PRODUCT_TABLES_BEGIN, })
const acGetProductTablesSuccess = payload => ({
  type: GET_PRODUCT_TABLES_SUCCESS, payload: { response: payload }
})
const acGetProductTablesFailure = err => ({
  type: GET_PRODUCT_TABLES_FAILURE, payload: err
})

export const acGetProductTables = () => {
  return dispatchFetchGet(
    `${URLS.PRODUCT.TABLE}`,
    acGetProductTablesBegin,
    acGetProductTablesSuccess,
    acGetProductTablesFailure,
  )
}

const acPostAddProductToProductTableBegin = () => ({ type: POST_ADD_PRODUCT_BEGIN, })
const acPostAddProductToProductTableSuccess = payload => ({
  type: POST_ADD_PRODUCT_SUCCESS, payload: { response: payload }
})
const acPostAddProductToProductTableFailure = err => ({
  type: POST_ADD_PRODUCT_FAILURE, payload: err
})

export const acPostAddProductToProductTable = (productTableId, productId, price) => {
  return dispatchFetchPost(
    `${URLS.PRODUCT.ADD_PRODUCT}`,
    {
      productTableId, productId, price
    },
    acPostAddProductToProductTableBegin,
    acPostAddProductToProductTableSuccess,
    acPostAddProductToProductTableFailure,
  )
}

const acPostCreateProductTableBegin = () => ({ type: POST_CREATE_PRODUCT_TABLE_BEGIN, })
const acPostCreateProductTableSuccess = payload => ({
  type: POST_CREATE_PRODUCT_TABLE_SUCCESS, payload: { response: payload }
})
const acPostCreateProductTableFailure = err => ({
  type: POST_CREATE_PRODUCT_TABLE_FAILURE, payload: err
})

export const acPostCreateProductTable = (productTable) => {
  return dispatchFetchPost(
    `${URLS.PRODUCT.TABLE}`,
    productTable,
    acPostCreateProductTableBegin,
    acPostCreateProductTableSuccess,
    acPostCreateProductTableFailure,
  )
}

const acPutUpdateProductTableBegin = () => ({ type: PUT_UPDATE_PRODUCT_TABLE_BEGIN, })
const acPutUpdateProductTableSuccess = payload => ({
  type: PUT_UPDATE_PRODUCT_TABLE_SUCCESS, payload: { response: payload }
})
const acPutUpdateProductTableFailure = err => ({
  type: PUT_UPDATE_PRODUCT_TABLE_FAILURE, payload: err
})

export const acPutUpdateProductTable = (productTableId, productTable) => {
  return dispatchFetchPut(
    `${URLS.PRODUCT.TABLE}/${productTableId}`,
    productTable,
    acPutUpdateProductTableBegin,
    acPutUpdateProductTableSuccess,
    acPutUpdateProductTableFailure,
  )
}

export const acInsertProductTableData = (productTable) => ({
  type: INSERT_PRODUCT_TABLE_DATA, payload: productTable
})

export const acClearAddedProducts = () => ({ type: CLEAR_ADDED_PRODUCTS })

export const acClearCurrentProductTableInfo = () => ({ type: CLEAR_CURRENT_PRODUCT_TABLE_INFO })

export const acResetProductTableState = () => ({ type: RESET_PRODUCT_TABLE_STATE })